import React, { useEffect, useState } from 'react'
import CustomCalendar from '../../Components/CustomCalendar'
import { useNavigate } from 'react-router-dom';
import Table from '../../Components/Table';
import { getNotices } from '../../Services/Notice/action';
import { connect } from 'react-redux';
import moment from 'moment';
import RoleWiseFeatureWrapper, { checkFeatureAccess } from '../../Lib/RoleWiseFeatureWrapper';
import ModulesList from '../../Assets/ModulesLiist';
import FeaturesList from '../../Assets/FeaturesList';
import { deleteRecord } from '../../Services/Delete/action';
import Skeleton from 'react-loading-skeleton';

const header = [
  // { field: "checkbox" },
  { field: "Notice" },
  { field: "Start Date" },
  { field: "No. of Days" },
  { field: "Action" },
];

function NoticeBoard(props) {
  const [inData, setInData] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [totalSelectedIds, setTotalSelectedIds] = useState([]);
  const navigate = useNavigate();

  const canView = checkFeatureAccess({
    modules: props?.modules,
    features: props?.features,
    user: props?.user,
    ModuleName: ModulesList.Notice,
    Featur_Name: FeaturesList.View,
  });

  const canDelete = checkFeatureAccess({
    modules: props?.modules,
    features: props?.features,
    user: props?.user,
    ModuleName: ModulesList.Notice,
    Featur_Name: FeaturesList.Delete,
  });

  const canEdit = checkFeatureAccess({
    modules: props?.modules,
    features: props?.features,
    user: props?.user,
    ModuleName: ModulesList.Notice,
    Featur_Name: FeaturesList.Update,
  });
  const handleChange = (event) => {
    const { type, checked, id, ids } = event;

    if (type === "select-all") {
      setTotalSelectedIds(checked ? [...ids] : []);
    } else if (type === "select-one") {
      if (checked) {
        setTotalSelectedIds(prev => [...prev, id]);
      } else {
        setTotalSelectedIds(prev => prev.filter(selectedId => selectedId !== id));
      }
    }
  };
  const fetchData = async () => {
    await props?.getNotices();
  }
  useEffect(() => {
    fetchData();
  }, [])

  useEffect(() => {
    const today = moment().startOf('day');

    setInData(
      props?.notice && props?.notice
        ?.filter((item) => {
          const startDate = moment(item?.start_date, 'YYYY-MM-DD');
          const noOfDays = parseInt(item?.no_of_days, 10) || 0;
          const endDate = moment(startDate).add(noOfDays, 'days');

          return today.isSameOrAfter(startDate) && today.isBefore(endDate);
        })?.map((item) => {
          const start_date = item?.start_date;
          const no_of_days = parseInt(item?.no_of_days, 10)
          return {
            checkbox: {
              value: item?.id,
              type: 'checkbox',
            },
            "Notice": {
              value: item?.heading,
              type: 'text'
            },
            "Start Date": {
              value:moment(start_date?.split(" ")[0]).format('YYYY-MM-DD'),
              type: 'text'
            },
            "No. of Days": {
              value: no_of_days,
              type: 'text'
            },
            Action: {
              value2: '/notice/view',
              value: '/notice/edit',
              value3: item?.id,
              value9: "",
              type: 'action'
            },
            allData: {
              ...item,
            }
          }
        })
    )
  }, [props?.notice]);

  const [selectFilters, setSelectedFilters] = useState({
    Search: "",
  });
  const [filteredStartDate, setFilteredStartDate] = useState(null);
  const [filteredEndDate, setFilteredEndDate] = useState(null);
  const [dateStatus, setDateStatus] = useState(false);

  const applyFilters = ({ startDate, endDate, search }) => {
    setFilteredStartDate(startDate);
    setFilteredEndDate(endDate);
    const filtered = inData?.filter((notice) => {
      let matchesSearch = true;
      let matchesDate = true;
      const Title = notice?.Notice?.value?.toLowerCase() || '';

      if (startDate && endDate) {
        setDateStatus(true);
        const itemStartDate = moment(notice?.Date?.value, 'YYYY-MM-DD').startOf('day').toDate();
        const itemDueDate = notice?.Date?.value
          ? moment(notice?.Date?.value, 'YYYY-MM-DD').endOf('day').toDate()
          : itemStartDate;

        const filterStart = moment(startDate).startOf('day').toDate();
        const filterEnd = moment(endDate).endOf('day').toDate();

        matchesDate =
          (itemStartDate >= filterStart && itemStartDate <= filterEnd) ||
          (itemDueDate >= filterStart && itemDueDate <= filterEnd);
      }
      if (search) {
        matchesSearch = Title.includes(search.toLowerCase());
      }

      return matchesSearch && matchesDate;
    });

    setFilteredData(filtered);
  };

  const handleClear = () => {
    setSelectedFilters({
      Search: ""
    });
    setFilteredStartDate(null);
    setFilteredEndDate(null);
    setFilteredData(inData);
    setDateStatus(false);

  };
  return (
    <div className='task-viewEmployee-main mb-5'>
      <div className="page-title">
        <h4>
          {
            props.loading ? (
              <Skeleton className='rounded-2' width={200} height={40} />
            ) : (
              "Notice Board"
            )
          }
        </h4>
        <div>
          {
            props.loading ? (
              <Skeleton className='badge rounded-pill' width={100} height={40} />
            ) : (
              <RoleWiseFeatureWrapper
                modules={props?.modules}
                features={props?.features}
                user={props?.user}
                ModuleName={ModulesList.Notice}
                Featur_Name={FeaturesList.Create}>

                <button
                  className="export-btn"
                  id="exportBtn"
                  // disabled={!checked || exportLoading}
                  onClick={(e) => {
                    e.preventDefault();
                    navigate("/notice/add")
                  }}
                >
                  {/* {exportLoading ? (
                            <Spinner
                            as="span"
                            animation="border"
                            className="custom-spinner"
                            role="status"
                            aria-hidden="true"
                            />
                            ) : (
                              "Export"
                              )} */}
                  Add Note
                </button>
              </RoleWiseFeatureWrapper>
            )
          }
        </div>
      </div>

      <div className='row'>
        <div className="col-lg-5 col-md-4 col-sm-12">
          {
            props.loading ? (
              <Skeleton className='rounded-2' width="100%" height={40} />
            ) : (
              <div className="card-type">
                <CustomCalendar
                  inData={inData}
                  setFilteredData={setFilteredData}
                  applyFilters={(params) => { applyFilters(params) }}
                  startDate={filteredStartDate}
                  endDate={filteredEndDate}
                  setStartDate={setFilteredStartDate}
                  setEndDate={setFilteredEndDate} />
              </div>
            )
          }
        </div>

        <div className="col-lg-5 col-md-4 col-sm-12">
          {
            props.loading ? (
              <Skeleton className='rounded-2' width="100%" height={40} />
            ) : (
              <div className="input-group">
                <input
                  type="text"
                  className="input-css"
                  name='search'
                  placeholder='Search...'
                  value={selectFilters.Search}
                  onChange={(e) => {
                    setSelectedFilters({
                      ...selectFilters,
                      Search: e.target.value,
                    })

                    applyFilters({ startDate: filteredStartDate, endDate: filteredEndDate, search: e.target.value })
                  }
                  }
                />
              </div>
            )
          }
        </div>
        <div className='col-lg-2 col-md-4 col-sm-12'>
          {(selectFilters?.Search || dateStatus) && (
            props.loading ? (
              <Skeleton className='badge rounded-pill' width={100} height={40} />
            ) : (
              <button
                className="export-btn"
                disabled={props.loading}
                onClick={handleClear}
              >Clear</button>
            )
          )}
        </div>

        {/* <div className='col-lg-12 col-md-12 '>
          

          <button
              className="export-btn"
              id="exportBtn"
            disabled={!checked || exportLoading}
            onClick={(e) => {
                e.preventDefault();
                handleClick(totalSelectedIds, "export");
            }}
            >
              {exportLoading ? (
                                    <Spinner
                                        as="span"
                                        animation="border"
                                        className="custom-spinner"
                                        role="status"
                                        aria-hidden="true"
                                    />
              ) : (
                'Export'
              )}
            </button> 
        </div> */}

        <div className='ticket-table col-lg-12 col-md-12 col-sm-12'>
          {
            props.loading ? (
              <Skeleton className='rounded-2' count={5} width="100%" height={40} />
            ) : (
              <Table
                header={header}
                data={(selectFilters?.Search || dateStatus) ? filteredData : inData}
                footer={true}
                showIsView={canView}
                showIsEdit={canEdit}
                showIsDelete={canDelete}
                count={inData.length}
                handleChange={handleChange}
                records={inData.length}
                loading={props.loading}
                deleteRecord={props?.deleteRecord}
              />
            )
          }
        </div>
      </div>
    </div>
  )
}

const mapStateToProps = (state) => {
  return {
    loading: state.noticeReducer.loading,
    notice: state.noticeReducer.notice,
    modules: state.authenticationReducer.modules,
    features: state.authenticationReducer.features,
    user: state.authenticationReducer.user,
  };
}

const mapDispatchToProps = (dispatch) => {
  return {
    getNotices: () => {
      dispatch(getNotices())
    },
    deleteRecord: async (id, inputValue) => {
      await dispatch(deleteRecord(id, inputValue))
      await dispatch(getNotices());
    }
  };
}
export default connect(mapStateToProps, mapDispatchToProps)(NoticeBoard);